import { REMOVE_NOTIFICATION } from './types';

export const removeNotification = () => async (dispatch) => {
	dispatch({
		type: REMOVE_NOTIFICATION,
		payload: null,
	});
};
